import styled from "styled-components";

export const TabContentContainer = styled.div`
  padding: 24px;
`;
